import { render } from "./CollapseBox.vue?vue&type=template&id=2e2f1c0a"
import script from "./CollapseBox.vue?vue&type=script&lang=js"
export * from "./CollapseBox.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__